(function ($) {
	$(document).ready(function() {

		// -------------------------- //
		// Define and Cache Variables //
		// -------------------------- //
		const productImgWrapper = $('#product-images');
		const productImg = productImgWrapper.find('img');
		
		const inputComplete = $('input[name=type][value=Complete]');
		const inputFrameset = $('input[name=type][value=Frameset]');
		const inputBikeTypeEnabled = $('input[name=type]:enabled');
		
		const inputGtin = $('#gtin');
		const inputGtinChildren = inputGtin.find('option');
		const inputGtinSelected = inputGtin.find('option:selected');
		const inputGtinWrapper = inputGtin.closest('.select');

		const fieldset = $('#buy fieldset');

		const priceOnPage = $('.price .usd');


		// --------------------------- //
		// 1: The Main Functions       //
		// The foundation of this tool //
		// --------------------------- //

		// --------------------------------------------- //
		// 1a: Building and Updating the Parametric Form //
		// --------------------------------------------- //

		function buildColorRadios() {
			let template     = document.getElementById('radios');
			let templateHtml = template.innerHTML;
			let listHtml     = '';

			for (var i in bikeOptions) {
				listHtml += templateHtml.replace(/{{value}}/g, bikeOptions[i].color)
										.replace(/{{id}}/g, 'color');
			}
			document.getElementById('color').innerHTML = listHtml;
		}

		// COLOR SWATCHES REMOVED FOR V1 PENDING UX RESEARCH
		// function buildColorSwatches() {
		// 	let template     = document.getElementById('swatches');
		// 	let templateHtml = template.innerHTML;
		// 	let listHtml     = '';

		// 	for (var i in bikeOptions) {
		// 		listHtml += templateHtml.replace(/{{swatchName}}/g, bikeOptions[i].color)
		// 								.replace(/{{swatchHex}}/g, bikeOptions[i].colorHex);
		// 	}
		// 	document.querySelector('#product-images .swatches').innerHTML = listHtml;
		// }

		function createInitialForm() {
			// Build color radio list
			buildColorRadios();

			// Build color swatches list
			//buildColorSwatches();

			// No need to build Bike Type, that is baked in

			let firstColor = $('#color label:first-child input');

			firstColor.prop('checked', true).click().change(); // only trigger .change() on the last element whose onChange affects buildForm()
			buildForm(firstColor.val());
		}

		// Once you have the bikeOptions array of objects built out, you can dynamically modify and populate the form
		function populateOptionsTemplate(array, templateID, target, callback) {
			//https://jonsuh.com/blog/javascript-templating-without-a-library/
			let template     = document.getElementById(templateID);
			let templateHtml = template.innerHTML;
			let listHtml     = '';

			// Loop through array dataArray, replace placeholder tags
			// with actual data, and generate final HTML
			for (var i = 0; i < array.length; i++) {
				listHtml += templateHtml.replace(/{{value}}/g, array[i])
										.replace(/{{id}}/g, target);
				//console.log(array[i]);
			}

			// Replace the HTML of select#size with final HTML
			document.getElementById(target).innerHTML = listHtml;
			
			if (callback !== null) {
				callback();
			}
		}

		function compareBikeTypes(isComplete, isFrameset) {
			let bikeTypesAvbl      = [];
			let existingBikeTypes  = [];
			
			// Build two arrays for bike types:
			// - one from the existing code on the page
			// - one from what is attached to the selected color
			if (isComplete) { bikeTypesAvbl.push('Complete'); }
			if (isFrameset) { bikeTypesAvbl.push('Frameset'); }
			inputBikeTypeEnabled.each(function() { existingBikeTypes.push($(this).val()); });

			// console.log('Bike Types available: ' + bikeTypesAvbl);
			// console.log('Existing bike types: ' + existingBikeTypes);

			// Compare bike types already on-page to the ones in the selection
			// Only make changes if there are differences between the two lists
			if (existingBikeTypes.length !== bikeTypesAvbl.length) { 
				setBikeType(isComplete, isFrameset);
			}
		}

		function setBikeType(isComplete, isFrameset) {
			// Check if the selected color is only available as a frameset
			if (isComplete !== true && isFrameset === true) {
				// console.log('complete unavailable, frameset available');
				inputComplete.prop('disabled', true);
				inputFrameset.prop('disabled', false).prop('checked', true).change();
			
			// Check if the selected color is only available as a complete
			} else if (isComplete === true && isFrameset !== true) {
				// console.log('complete available, frameset unavailable');
				inputComplete.prop('disabled', false).prop('checked', true).change();
				inputFrameset.prop('disabled', true);

			// Available as both a complete and frameset, all [disabled] reverted
			} else {
				// console.log('both complete and frameset are available');
				inputFrameset.prop('disabled', false);
				inputComplete.prop('disabled', false).prop('checked', true).change();
			}
		}

		function populateFrameSizes(selectedColorObj) {
			let frameSizes          = selectedColorObj.frameSizes;

			populateOptionsTemplate(frameSizes, 'radios', 'frame-size', function(){
				let inputFrameSizeFirst = $('#frame-size label:first-child input');
				inputFrameSizeFirst.prop('checked', true).change();
			});
		}

		function compareFrameSizes(selectedColorObj) {
			let inputFrameSize     = $('input[name=frame-size]');
			let frameSizesAvbl     = [];
			let existingFrameSizes = [];

			// Build two arrays for frame size:
			// - one from the existing code on the page
			// - one from what is attached to the selected color
			for (var i = 0; i < selectedColorObj.frameSizes.length; i++) { frameSizesAvbl.push(selectedColorObj.frameSizes[i]); }
			inputFrameSize.each(function() { existingFrameSizes.push($(this).val()); });

			// Compare frame sizes already on-page to the ones in the selection
			// Only populate new Frame sizes if there are differences
			if (!existingFrameSizes.every( e => frameSizesAvbl.includes(e))) { // https://stackoverflow.com/a/49218423
				
				// Populate Frame Sizes
				populateFrameSizes(selectedColorObj);
				
				return;
			}
		}

		// Select objects in an array by value
		const getObj = (p, o) => p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o) // https://medium.com/javascript-inside/safely-accessing-deeply-nested-values-in-javascript-99bf72a0855a

		function buildForm(color) {
			let selectedColorObj = bikeOptions.find(o => o.color === color); // https://stackoverflow.com/a/12462414
			let isComplete       = getObj(['complete'], selectedColorObj);
			let isFrameset       = getObj(['frameset'], selectedColorObj);
			
			// console.log(selectedColorObj);

			compareBikeTypes(isComplete, isFrameset);
			compareFrameSizes(selectedColorObj);
			populateFrameSizes(selectedColorObj);
		}

		// ---------------------------------------------- //
		// 1b: Swap Product Image on Parametric Selection //
		// ---------------------------------------------- //

		function productImgSwap(selectedColor, selectedType) {
			// Select the first matching image during parametric attribute selection
			if (productImg.length) {
				// Default for Product Images using the deprecated pre-Bike Inventory Online fields
				let matchingAttr = '[data-type="' + selectedType + '"]';

				// For Product Images using the 2019 Bike Inventory Online fields
				if (productImg[0].hasAttribute('data-color')) {
					matchingAttr = '[data-color="' + selectedColor + '"][data-type="' + selectedType + '"]';
				}
				
				productImg.prop('hidden', true);
				productImgWrapper.find(matchingAttr).prop('hidden', false);

				// console.log('image swap triggered. Selected color: ' + selectedColor + ', selected type: ' + selectedType);
			}
		}


		// ----------------------------------------------- //
		// 1c: Sync Parametric Form Updates to select#gtin //
		// ----------------------------------------------- //
		
		function syncParametricFormToGtin(selectedColor, selectedType, selectedSize) {
			let matchingAttr  = '[data-color="' + selectedColor + '"][data-type="' + selectedType + '"][data-frame-size="' + selectedSize + '"]',
				matchingGtin  = inputGtin.find(matchingAttr);

			// console.log(matchingAttr);

			inputGtinChildren.prop('selected', false);

			// If a fully-matched GTIN is found, activate it
			if (matchingGtin.length) {
				matchingGtin.prop('selected', true).change();
				// console.log('match found');
			}
			
			// console.log('color: ' + selectedColor + ', type: ' + selectedType + ', size: ' + selectedSize);
		}


		// ------------------------------------ //
		// 1d: Update Price with GTIN selection //
		// ------------------------------------ //

		function updateProductPrice() {
			const selectedGtin = inputGtinSelected;
			let priceUsd = selectedGtin.data('price-usd');

			priceOnPage.html(priceUsd);
			//console.log('price changed to ' + selected.data('color') + ', ' + selected.data('type') + ', ' + selected.data('frame-size'));
		}


		// ---------------------------------------------------------- //
		// 2: Check Data                                              //
		// Prevent missing content causing the building a broken form //
		// ---------------------------------------------------------- //

		let systemOn = false;
		let gtinDataAttrFilled = [];

		$('select#gtin option').each(function() {
			let color     = $(this).data('color'),
				colorHex  = $(this).data('color-hex'),
				type      = $(this).data('type');

			// if (colorExists)     { console.log('data-color found');      }
			// if (colorHexExists)  { console.log('data-color-hex found');  }
			// if (typeExists)      { console.log('data-type found');       }

			// Check if data attributes exist and are filled out
			// https://stackoverflow.com/questions/46927069/check-if-data-attribute-is-not-empty/46927108
			if (color && color !== '' 
				&& colorHex && colorHex !== '' 
				&& type && type !== '') {
				gtinDataAttrFilled.push(1);
			} else {
				gtinDataAttrFilled.push(0);
			}
		});

		// console.log(gtinDataAttrFilled);

		function allTrue(currentValue) { // https://stackoverflow.com/questions/14832603/check-if-all-values-of-array-are-equal
			return currentValue == 1;
		}

		if (gtinDataAttrFilled.every(allTrue)) {
			//console.log('all GTIN attributes have been filled');
			systemOn = true;
		}



		// ------------------------------------------------------------------------------ //
		// 3: Run                                                                         //
		// If all GTIN items have all the necessary fields filled out, turn the system on //
		// ------------------------------------------------------------------------------- //

		if (systemOn) {

			// Define primary array, which will contain objects sorted by color
			var bikeOptions = [];

			// Define arrays inside of which to put all available colors, including duplicates
			var allBikeColors     = [];
			var allBikeColorHexes = [];

			// Get all colors available
			inputGtinChildren.each(function() {
				let bikeColorName = $(this).data('color'),
					bikeColorHex  = $(this).data('color-hex');

				// Push each color result to their respective arrays
				allBikeColors.push(bikeColorName);
				allBikeColorHexes.push(bikeColorHex);
			});

			// Preserve only the unique colors
			let uniqueBikeColorNames = [...new Set(allBikeColors)];
			let uniqueBikeColorHexes = [...new Set(allBikeColorHexes)];

			// Loop through all unique colors to build an array of objects, using color as the primary delineator
			for (var i = 0; i< uniqueBikeColorNames.length; i++) {
				let currentColor = uniqueBikeColorNames[i];

				// Define arrays inside of which to put all available bike types and frame sizes, including duplicates
				let allBikeTypes       = [];
				let filteredFrameSizes = [];

				// Grab the bike types and frame sizes associated with the current color
				inputGtin.find('[data-color="' + currentColor + '"]').each(function() {
					allBikeTypes.push($(this).data('type'));
					filteredFrameSizes.push($(this).data('frame-size'));
				});

				// Preserve only unique bikeTypes per color
				let uniqueBikeTypes  = [...new Set(allBikeTypes)];
 				
 				// Preserve only the unique frameSizes per color
 				let uniqueFrameSizes = [...new Set(filteredFrameSizes)];

				// Set properties
				bikeOptions[i] = {
					// Set color
				    color: uniqueBikeColorNames[i],
				    // Set colorHex
				    colorHex: uniqueBikeColorHexes[i],
				    // Set complete (boolean)
				    complete: uniqueBikeTypes.includes('Complete'),
				    // Set frameset (boolean)
				    frameset: uniqueBikeTypes.includes('Frameset'),
				    // Set sizes array
				    frameSizes: uniqueFrameSizes
				};
				// Final result example:
				// [
				// 	{
				// 		color: "Black",
				// 		colorHex: '#000000',
				// 		complete: true,
				// 		frameset: true,
				// 		frameSizes: ['X-Small','Small','Medium'] 
				// 	},
				// 	{
				// 		color: "'Rhymes With' Orange",
				// 		colorHex: '#c4b654',
				// 		complete: true,
				// 		frameset: true,
				// 		frameSizes: ['X-Small','Small','Medium']
				// 	},
				// 	{
				// 		color: "Green",
				// 		colorHex: '#2c5320',
				// 		complete: false,
				// 		frameset: true,
				// 		frameSizes: ['Medium','Large','X-Large'] 
				// 	}
				// ];
			}
			
			// console.log(bikeOptions);

			// Create initial form fields with select#gtin as non-JS fallback
			inputGtinWrapper.prop('hidden', true);
			fieldset.prop('hidden', false);

			createInitialForm();

			// Parametric ecommerce attribute selection, sync with select#gtin
			$(document).on('change', 'form#buy input[name="color"]', function(){
				// Utilize the currently checked Color and Frame Size to make decisions
				var selColor = $('form#buy input[name="color"]:checked').val();
				// console.log('form change triggered');
				buildForm(selColor);
			});

			$(document).on('change', 'form#buy input[type=radio]', function(){
				let selectedColor = $('input[name=color]:checked').val(),
					selectedType  = $('input[name=type]:checked').val(),
					selectedSize  = $('input[name=frame-size]:checked').val();
				
				syncParametricFormToGtin(selectedColor, selectedType, selectedSize);
			});
		}
		
		$(document).on('change', '#gtin', function(){
			let selectedGtin  = $(this).find('option:selected'),
				selectedColor = selectedGtin.data('color'),
				selectedType  = selectedGtin.data('type');

			// updateProductPrice();
			// console.log('GTIN changed. Selected color: ' + selectedColor + ', selected type: ' + selectedType);
			productImgSwap(selectedColor, selectedType);
		});

		// Trigger change when page is finished loading
		if (productImg.length) {
			inputGtin.change();
		}
	});
}(jQuery));